@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          @if (vendedor == null) {
            <div class="titulo_texto">Novo Vendedor(a)</div>
          }
          @if (vendedor != null) {
            <div class="titulo_texto">Alterar Vendedor(a)</div>
          }
        </div>
      </div>
    </div>
    <!-- Dados -->
    <div class="pt-3 pr-4 pb-4 pl-4">
      @if (podeGerenciarCarteiras) {
        <div class="nav nav-tabs mb-3 carteira-abas" role="tablist" aria-label="Cadastro do vendedor">
          <button id="aba-dados" class="nav-link" type="button" role="tab" [class.active]="abaAtiva === 'dados'" [attr.aria-selected]="abaAtiva === 'dados'" aria-controls="painel-dados" (click)="abrirAba('dados')">Dados e permissões</button>
          <button id="aba-carteiras" class="nav-link" type="button" role="tab" [class.active]="abaAtiva === 'carteiras'" [attr.aria-selected]="abaAtiva === 'carteiras'" aria-controls="painel-carteiras" (click)="abrirAba('carteiras')">Carteiras vinculadas</button>
        </div>
      }
      <section id="painel-dados" [hidden]="abaAtiva !== 'dados'" aria-label="Dados e permissões">
      <form [formGroup]="formDados" (ngSubmit)="salvar()">
        <div class="form-row">
          <div class="form-group" [ngClass]="flag_gerencia_permissoes ? 'col-sm-9' : 'col-sm-12'">
            <label><b>Nome:</b></label>
            <input class="form-control form-control-sm" type="text" name="nome" [ngClass]="{ 'is-invalid': enviado && f.nome.errors?.required }" formControlName="nome" />
            @if (enviado && f.nome.errors?.required) {
              <div class="erro pt-1">Nome em branco!</div>
            }
          </div>
          @if (flag_gerencia_permissoes) {
            <div class="form-group col-sm-3">
              <label><b>Licença Ativa:</b></label>
              <select class="form-control form-control-sm" name="licenca_ativa" #licenca_ativa (change)="selecionarLicencaAtiva(licenca_ativa.value)">
                <option value="0" [selected]="!licencaAtivaSelecionada">Não</option>
                <option value="1" [selected]="licencaAtivaSelecionada">Sim</option>
              </select>
            </div>
          }
        </div>
        <div class="form-row">
          <div class="form-group col-sm-6">
            <label><b>E-mail:</b></label>
            <input class="form-control form-control-sm" type="text" name="email" [ngClass]="{ 'is-invalid': enviado && f.email.errors?.required }" formControlName="email" />
            @if (enviado && f.email.errors?.required) {
              <div class="erro pt-1">E-mail em branco!</div>
            }
          </div>
          <div class="form-group col-sm-2">
            <label><b>Documento:</b></label>
            <input class="form-control form-control-sm" type="text" name="documento" [ngClass]="{ 'is-invalid': enviado && f.documento.errors?.required }" formControlName="documento" />
            @if (enviado && f.documento.errors?.required) {
              <div class="erro pt-1">Documento em branco!</div>
            }
          </div>
          <div class="form-group col-sm-2">
            <label><b>Código (Região):</b></label>
            <input class="form-control form-control-sm" type="text" name="codigo_regiao" formControlName="codigo_regiao" />
          </div>
          <div class="form-group col-sm-2">
            <label><b>Código (Vendedor):</b></label>
            <input class="form-control form-control-sm" type="text" name="codigo_vendedor" formControlName="codigo_vendedor" />
          </div>
        </div>
        <!-- Gerente -->
        <div class="form-row">
          <div class="form-group col-sm-12">
            <label><b>Gerente:</b></label>
            <select class="form-control form-control-sm" name="gerente" #gerente (change)="selecionarGerente(gerente.value)">
              <option value="0" [selected]="gerenteSelecionado == null"></option>
              @for (opcao of gerentes; track opcao) {
                <option [value]="opcao.id" [selected]="gerenteSelecionado != null ? opcao.id == gerenteSelecionado.id : null">{{ opcao.fullname }}</option>
              }
            </select>
          </div>
        </div>
        <!-- Telemarketing -->
        <div class="form-row">
          <div class="form-group col-sm-12">
            <label><b>Venda Interna:</b></label>
            <select class="form-control form-control-sm" name="telemarketing" #telemarketing (change)="selecionarTelemarketing(telemarketing.value)">
              <option value="0" [selected]="telemarketingSelecionado == null"></option>
              @for (opcao of telemarketings; track opcao) {
                <option [value]="opcao.id" [selected]="telemarketingSelecionado != null ? opcao.id == telemarketingSelecionado.id : null">{{ opcao.fullname }}</option>
              }
            </select>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-2">
            <label><b>Ativo:</b></label>
            <select class="form-control form-control-sm" name="ativo" #ativo (change)="selecionarAtivo(ativo.value)">
              <option value="0" [selected]="!vendedorAtivo">Não</option>
              <option value="1" [selected]="vendedorAtivo">Sim</option>
            </select>
          </div>
          @if (vendedorExterno) {
            <div class="form-group col-sm-3">
              <label for="foto_checkout_obrigatorio"><b>Foto Obrigatória no Check Out:</b></label>
              <select id="foto_checkout_obrigatorio" class="form-control form-control-sm" formControlName="foto_checkout_obrigatorio">
                <option [ngValue]="true">Sim</option>
                <option [ngValue]="false">Não</option>
              </select>
            </div>
            <div class="form-group col-sm-3">
              <label for="permite_check_in_distante"><b>Permite Check In Distante do Cliente:</b></label>
              <select id="permite_check_in_distante" class="form-control form-control-sm" formControlName="permite_check_in_distante">
                <option [ngValue]="true">Sim</option>
                <option [ngValue]="false">Não</option>
              </select>
            </div>
            <div class="form-group col-sm-3">
              <label for="flag_tira_foto_odometro"><b>Obrigatório Foto do Odômetro:</b></label>
              <select id="flag_tira_foto_odometro" class="form-control form-control-sm" formControlName="flag_tira_foto_odometro">
                <option [ngValue]="true">Sim</option>
                <option [ngValue]="false">Não</option>
              </select>
            </div>
          }
        </div>
        <hr class="mt-2 mb-2" />
        <div class="d-flex flex-wrap justify-content-between">
          <div class="flex-grow-1 text-right">
            <button class="btn btn-success btn_formulario" type="submit">Salvar</button>
          </div>
        </div>
      </form>
      <!-- Permissões Especiais -->
      @if (vendedor != null && permissoesCarregadas) {
        <div class="card mt-3">
          <div class="card-header">
            <strong>Permissões Especiais</strong>
            <small class="text-muted ml-2">— desmarque para bloquear o acesso</small>
          </div>
          <div class="card-body">
            @for (grupo of gruposPermissao; track grupo; let primeiro = $first) {
              <div class="d-flex align-items-center mb-2" [class.mt-3]="!primeiro">
                <strong class="mr-3">{{ grupo }}</strong>
                <a href="javascript:void(0)" class="small mr-2" (click)="definirGrupo(grupo, false)">Marcar todos</a>
                <a href="javascript:void(0)" class="small" (click)="definirGrupo(grupo, true)">Desmarcar todos</a>
              </div>
              <div class="row">
                @for (perm of permissoesDoGrupo(grupo); track perm.chave) {
                  <div class="col-md-4 mb-2">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [id]="'perm_' + perm.chave"
                        [checked]="!estaBloqueado(perm.chave)"
                        (change)="alternarPermissao(perm.chave, !($event.target)['checked'])"
                      />
                      <label class="form-check-label" [for]="'perm_' + perm.chave">
                        {{ perm.label }}
                      </label>
                    </div>
                  </div>
                }
              </div>
              @if (grupo === 'Geral' && !estaBloqueado('pedidos_aprovar')) {
                <hr class="mt-2 mb-2" />
                <div class="form-group mb-0">
                  <label><b>Nível de aprovação de pedidos:</b></label>
                  <select class="form-control form-control-sm" [(ngModel)]="nivelAprovacao" [ngModelOptions]="{standalone: true}">
                    <option value="">Nenhum</option>
                    <option value="IS_MASTER">Master</option>
                    <option value="IS_DIRETOR">Diretor</option>
                    <option value="IS_FINANCEIRO">Financeiro</option>
                    <option value="IS_MANAGER">Gerente</option>
                  </select>
                </div>
              }
            }
          </div>
        </div>
      }
      <!-- Equipe do Master -->
      @if (vendedor != null && vendedor.is_master) {
        <div class="mt-3">
          <hr class="mt-0 mb-3" />
          <label><b>Equipe do Master</b></label>
          <p class="text-muted small mb-2">
            <i>Sem vendedores vinculados = master tem acesso total a todos os sellers do tenant.</i>
          </p>
          <!-- Chips dos sellers vinculados -->
          <div class="mb-2">
            @if (masterScope.length === 0) {
              <span class="text-muted small">Nenhum vínculo ativo.</span>
            }
            @for (s of masterScope; track s) {
              <span
                class="badge badge-secondary mr-1 mb-1"
                style="font-size: 0.85em; padding: 5px 8px;">
                {{ s.fullname }}
                <span (click)="removerSeller(s.id)"
                style="cursor: pointer; margin-left: 4px;">&times;</span>
              </span>
            }
          </div>
          <!-- Campo de busca -->
          <div class="input-group input-group-sm mb-1" style="max-width: 400px;">
            <input class="form-control form-control-sm"
              type="text"
              placeholder="Buscar vendedor para adicionar..."
              [(ngModel)]="masterScopeBusca"
              (input)="buscarSellers()" />
          </div>
          <!-- Resultados da busca -->
          @if (masterScopeSearch.length > 0) {
            <ul class="list-group mb-2" style="max-width: 400px;">
              @for (s of masterScopeSearch; track s) {
                <li
                  class="list-group-item list-group-item-action py-1 px-2"
                  style="cursor: pointer; font-size: 0.9em;"
                  (click)="adicionarSeller(s)">
                  {{ s.fullname }}
                </li>
              }
            </ul>
          }
          <!-- Botão salvar -->
          <button class="btn btn-info btn-sm"
            type="button"
            (click)="salvarVinculos()"
            [disabled]="masterScopeSalvando">
            {{ masterScopeSalvando ? 'Salvando...' : 'Salvar vínculos' }}
          </button>
        </div>
      }
      </section>
      @if (podeGerenciarCarteiras) {
        <section id="painel-carteiras" [hidden]="abaAtiva !== 'carteiras'" role="tabpanel" aria-labelledby="aba-carteiras" [attr.aria-busy]="carteirasCarregando || carteirasSalvando">
          <div class="d-flex justify-content-between flex-wrap align-items-center mb-3">
            <div>
              <h2 class="carteira-titulo">Carteiras vinculadas</h2>
              <p class="text-muted mb-0">{{ vendedor.fullname }} poderá acessar as carteiras dos vendedores vinculados abaixo.</p>
            </div>
            <button type="button" class="btn btn-outline-secondary btn-sm mt-2" (click)="carregarCarteiras()" [disabled]="carteirasCarregando || carteirasSalvando">Recarregar</button>
          </div>
          @if (carteiraErro) { <div class="alert alert-danger" role="alert">{{ carteiraErro }}</div> }
          @if (carteirasCarregando) { <p role="status">Carregando carteiras...</p> }
          @if (carteirasCarregadas && !carteirasCarregando) {
            <fieldset class="carteira-editor" [disabled]="carteirasSalvando">
              <legend class="sr-only">Vincular vendedor</legend>
              <div class="carteira-adicionar p-3 mb-3">
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label for="carteira-busca"><b>Buscar vendedor:</b></label>
                    <div class="input-group">
                      <input id="carteira-busca" class="form-control" placeholder="Nome, código ou ID" maxlength="100" [(ngModel)]="carteiraBusca" (keydown.enter)="$event.preventDefault(); buscarCarteiras()" />
                      <div class="input-group-append"><button type="button" class="btn btn-secondary" (click)="buscarCarteiras()" [disabled]="carteiraBuscando">{{ carteiraBuscando ? 'Buscando...' : 'Buscar' }}</button></div>
                    </div>
                  </div>
                  <div class="form-group col-md-7">
                    <label for="carteira-vendedor"><b>Vendedor:</b></label>
                    <select id="carteira-vendedor" class="form-control" [(ngModel)]="carteiraSelecionada">
                      <option [ngValue]="0">Selecione um vendedor encontrado</option>
                      @for (item of carteiraOpcoes; track item.seller_vinculado) {
                        <option [ngValue]="item.seller_vinculado">{{ item.fullname }} — {{ item.codigo || item.seller_vinculado }}</option>
                      }
                    </select>
                  </div>
                </div>
                @if (carteiraBuscou && !carteiraBuscando) {
                  <p class="text-muted small" role="status">{{ carteiraOpcoes.length ? 'Até 50 resultados. Refine a busca se necessário.' : 'Nenhum vendedor disponível nesta busca.' }}</p>
                }
                <div class="d-flex flex-wrap align-items-end carteira-adicionar-acoes">
                  <div class="carteira-acesso">
                    <label for="carteira-acesso"><b>Acesso aos clientes:</b></label>
                    <select id="carteira-acesso" class="form-control" [(ngModel)]="carteiraVerTodos">
                      <option [ngValue]="false">Somente inativos e leads</option>
                      <option [ngValue]="true">Todos os clientes</option>
                    </select>
                  </div>
                  <button type="button" class="btn btn-info" (click)="adicionarCarteira()" [disabled]="!carteiraSelecionada || carteiraBuscando">+ Vincular</button>
                </div>
              </div>
              <p class="mb-2">{{ carteiras.length }} vendedor(es) vinculado(s)</p>
              <div class="table-responsive">
                <table class="table table-bordered carteira-tabela">
                  <thead class="bg-light"><tr><th>Vendedor vinculado</th><th>Acesso aos clientes</th><th>Ações</th></tr></thead>
                  <tbody>
                    @for (item of carteiras; track item) {
                      <tr>
                        <td><strong>{{ item.fullname }}</strong><br /><small class="text-muted">ID {{ item.seller_vinculado }}{{ item.codigo ? ' · ' + item.codigo : '' }}</small></td>
                        <td><select class="form-control" [attr.aria-label]="'Acesso aos clientes de ' + item.fullname" [(ngModel)]="item.ver_todos" (ngModelChange)="carteirasAlteradas = true"><option [ngValue]="false">Somente inativos e leads</option><option [ngValue]="true">Todos os clientes</option></select></td>
                        <td><button type="button" class="btn btn-outline-danger btn-sm" [attr.aria-label]="'Remover vínculo com ' + item.fullname" (click)="removerCarteira(item)">Remover</button></td>
                      </tr>
                    } @empty {
                      <tr><td colspan="3" class="text-center text-muted py-4">Nenhuma carteira vinculada. Busque um vendedor para adicionar.</td></tr>
                    }
                  </tbody>
                </table>
              </div>
              <p class="text-muted small">Os vínculos não transferem clientes. Inclusões, remoções e mudanças de acesso só serão aplicadas ao salvar vínculos.</p>
              <div class="d-flex justify-content-between flex-wrap align-items-center">
                <span class="text-muted" role="status">{{ carteirasAlteradas ? 'Há alterações não salvas nesta aba.' : '' }}</span>
                <button type="button" class="btn btn-success btn_formulario" (click)="salvarCarteiras()" [disabled]="!carteirasAlteradas || carteirasSalvando">{{ carteirasSalvando ? 'Salvando...' : 'Salvar vínculos' }}</button>
              </div>
            </fieldset>
          }
        </section>
      }
    </div>
  </div>
}
